import React from "react";
import styled, { keyframes } from "styled-components";
import { COLORS } from "../definitions/colors";

const ProductOption = (props) => {

    const fadeInUp = keyframes`
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    `;

    const Holder = styled.div`
        width: calc(50% - 1rem);
        opacity: 0;
        animation: ${fadeInUp} 0.6s ease-out forwards;

        @media (max-width: 758px) {
            width: 100%;
        }
    `

    const Background = styled.div`
        position: relative;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        background: linear-gradient(135deg, #1a0d10 0%, ${COLORS.accent} 40%, #3d1f26 100%);
        margin: 0.5rem;
        padding: 0;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        min-height: 500px;
        border: 3px solid ${COLORS.accent};

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        }

        @media (max-width: 758px){
            min-height: 100px;
        }
    `

    const FirstSection = styled.div`
        display: flex;
        flex-direction: column;
        flex: 1;
    `

    const Image = styled.img`
        aspect-ratio: 1.5 / 1;
        width: 100%;
        object-fit: cover;
    `

    const Info = styled.div`
        display: flex;
        justify-content: start;
        flex-direction: column;
        padding: 1.2rem;
        transition: 0.3s;
        color: ${COLORS.whiteText};
        text-decoration: none;
        flex: 1;
        min-height: 100px;
    `

    const ProductName = styled.h1`
        font-size: 1.7em;
        position: relative;
        margin: 0 0 0.8rem 0;
        font-weight: bold;
        color: ${COLORS.whiteText};
        line-height: 1.3;
    `

    const MoreInfo = styled.div`
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 1.2rem;
        box-sizing: border-box;
    `

    const Description = styled.p`
        font-size: 1.1em;
        line-height: 1.6;
        margin: 0;
        opacity: 0.95;
        color: ${COLORS.whiteText};
    `

    const Cost = styled.p`
        background: ${COLORS.whiteText};
        color: ${COLORS.accent};
        padding: 0.6rem 1rem;
        border-radius: 25px;
        font-size: 1.4em;
        font-weight: bold;
        margin: 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        white-space: nowrap;
        flex-shrink: 0;
    `

    return (
        <Holder>
            <Background>
                <FirstSection>
                    <Image src={props.product.img_path} alt={props.product.name}></Image>
                    <Info>
                        <ProductName>{props.product.name}</ProductName>
                        <Description>{props.product.description}</Description>
                    </Info>
                </FirstSection>
                <MoreInfo>
                    <Cost>{props.product.cost}kr/{props.product.per}</Cost>
                </MoreInfo>
            </Background>
        </Holder>
    )
}

export default ProductOption
